module.exports = __webpack_public_path__ + "static/media/Baobab_MCF_Logo_FullColor.6bf55de6.svg";